<template>
  <div>
    <div class="google-maps">
      <div class="form-group">
        <input @input="schoolAutoComplete" type="text" ref="searchSchool" class="form-control custom-input" placeholder="Find your driving school here"/>
        <span @click="schools=[]; isSchoolAuto=false" v-if="isSchoolAuto" class="append-close"><i class="mdi mdi-close"></i></span>
        <div class="scroll-dropdown" v-if="isSchoolAuto">
          <ul >
            <li class="li-class" :ref="`schoolLoad_${index}`" @click="schoolSelectHandle($event,school)" :key="`school-${index}`" v-for="(school,index) in schools">{{school.name+" "+school.address}}</li>
          </ul>
        </div>
      </div>

      <div class="form-group">
<!--        :disabled="isOperateIndefendent"-->
        <input @click="googleMapRender" id="input-search" type="text" :class="isOperateIndefendent?'form-control custom-input':'form-control custom-input'" placeholder="Search Location"/>
      </div>
      <div class="google-map" :id="mapName"></div>

      <v-dialog v-model="isSchoolRegister" persistent width="500">
        <v-card style="padding: 50px">
          <button @click="isSchoolRegister = false" class="btn-close" type="button"><i class="mdi mdi-close"></i></button>
          <v-card-text>
            <div class="tab-upper-header">
              <div class="v-img">
                <img alt="Congratulations" :src="require('@/assets/img/popupimg.svg')"  />
              </div>
            </div>
            <div class="text-center">
              <v-alert
                dense
                text
                type="success"
              >
              <p class="font-13 mb-0" style="font-size: 21px;line-height: 30px;font-weight: 400">The School is registered under Driverx, the school would approve your identity.</p>
              </v-alert>
              <v-btn style="margin-top: 30px" color="primary" light @click="isSchoolRegister = false">Continue</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isSchoolVerification" persistent width="500">
        <v-card style="padding: 50px">
          <button @click="isSchoolVerification = false"  class="btn-close" type="button"><i class="mdi mdi-close"></i></button>
          <v-card-text>
            <div class="tab-upper-header">
              <div class="v-img">
                <img alt="Congratulations" :src="require('@/assets/img/popupimg.svg')"  />
              </div>
            </div>
            <div class="text-center">
              <v-alert
                dense
                text
                type="success"
              >
                <p class="mb-0 font-13">Your school is not registered with driver X you are going to operate independently, we will contact your school to verify you.</p>

              </v-alert>
              <v-btn style="margin-top: 30px" color="primary" light @click="isSchoolVerification = false">Continue</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import loader from '../../Map'
import mapMarker from '../../assets/img/icons/mapMarker.png'
import Parse from 'parse'
import { removeDuplicateItem } from '../../Helper'
export default {
  name: 'OperateIndependently',
  data () {
    return {
      mapName: 'mwsMap',
      options: {
        key: 'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0',
        libraries: 'places'
      },
      map: null,
      isSearchMapRender: true,
      schools: [],
      isSchoolAuto: false,
      isSchoolRegister: false,
      isSchoolRegister1: false,
      isSchoolVerification: false,
      SchoolRegisterId: '',
      isOperateIndefendent: true,
      maps: null,
      center: { lat: 45.43192011908615, lng: -75.67619515391746 },
      markers: [],
      places: [],
      pageIndex: 1
    }
  },
  mounted () {
    this.loadMap()
  },
  watch: {
    isSchoolRegister (value) {
      if (value) {
        this.isSchoolRegister1 = true
      }
    }
  },
  methods: {

    googleMapRender () {
      if (this.isSearchMapRender) {
        this.loadMap()
        this.isSearchMapRender = false
      }
      console.log('click')
    },
    loadMap () {
      loader.load().then((google) => {
        document.getElementById('mwsMap').innerHTML = ''
        const map = new google.maps.Map(document.getElementById('mwsMap'), {
          center: this.center,
          zoom: 15,
          mapId: 'bbde0a4612d9966e'
        })
        const input = document.getElementById('input-search')
        const searchBox = new google.maps.places.SearchBox(input)
        console.log(searchBox, 'searchBox')
        // map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)
        map.addListener('bounds_changed', () => {
          searchBox.setBounds(map.getBounds())
        })
        let markers = []
        searchBox.addListener('places_changed', () => {
          const places = searchBox.getPlaces()
          if (places.length === 0) {
            return
          }

          // Clear out the old markers.
          markers.forEach((marker) => {
            marker.setMap(null)
          })
          markers = []

          const bounds = new google.maps.LatLngBounds()
          let infoWindow = ''
          places.forEach((place) => {
            if (!place.geometry || !place.geometry.location) {
              console.log('Returned place contains no geometry')
            }
            const marker = new (google.maps.Marker)({
              position: place.geometry.location,
              map: map,
              icon: mapMarker
            })
            const address = place.formatted_address
            const infowindow = new google.maps.InfoWindow({
              content: `<div class="business"><div class="business-name">${place.name}</div><div>Address: ${address}</div></div>`
            })
            marker.addListener('click', () => {
              if (infoWindow !== '') {
                infoWindow.close()
              }
              if (this.isSchoolVerification) {
                this.isSchoolVerification = false
              }
              infoWindow = infowindow
              this.showMarker(infowindow, address, place.name, marker, map)
              this.isSchoolVerification = true
            })
            markers.push(marker)
            if (place.geometry.viewport) {
              // Only geocodes have viewport.
              bounds.union(place.geometry.viewport)
            } else {
              bounds.extend(place.geometry.location)
            }
          })
          map.fitBounds(bounds)
        })
      })
    },
    async schoolSelectHandle (e, school) {
      this.isSearchMapRender = true
      this.isSchoolAuto = false
      const instance = this
      const { schoolId } = school
      console.log(school, schoolId, 'School')
      document.getElementById('input-search').value = ''
      if (schoolId === undefined) {
        instance.isSchoolRegister = false
        instance.SchoolRegisterId = ''
      } else {
        instance.isSchoolRegister = true
        instance.SchoolRegisterId = schoolId
      }
      instance.schools.map((row, index) => {
        if (school.id === row.id) {
          try {
            instance.$refs[`schoolLoad_${index}`][0].classList.add('active')
          } catch (e) {
            console.log(e)
          }
        } else {
          try {
            instance.$refs[`schoolLoad_${index}`][0].classList.remove('active')
          } catch (e) {
            console.log(e)
          }
        }
      })

      loader.load().then((google) => {
        document.getElementById('mwsMap').innerHTML = ''
        const map = new google.maps.Map(document.getElementById('mwsMap'), {
          center: this.center,
          zoom: 15,
          mapId: 'bbde0a4612d9966e'
        })
        const position = school.location
        const marker = new (google.maps.Marker)({
          position: position,
          map: map,
          icon: mapMarker
        })
        const infowindow = new google.maps.InfoWindow({
          content: `<div class="business"><div class="business-name">${school.name}</div><div>Address: ${school.address}</div></div>`
        })
        let infoWindow = ''
        infowindow.open({
          anchor: marker,
          map,
          shouldFocus: false
        })
        if (this.isSchoolRegister === false) {
          this.isSchoolVerification = true
        }
        marker.addListener('click', () => {
          if (infoWindow !== '') {
            infoWindow.close()
          }
          infoWindow = infowindow
        })
        instance.$emit('SchoolSelected', {
          address: school.address,
          name: school.name,
          phone: school.phone,
          registerSchoolId: school.id,
          schoolId: this.SchoolRegisterId,
          isOperateIndefendent: this.isOperateIndefendent, /* invert status for furture using  */
          isSelectSchool: true
        })
        map.setCenter(position)
      })
    },
    schoolAutoComplete (e) {
      const { value } = e.target
      const RegisterSchools = new Parse.Query('RegisterSchools')
      RegisterSchools.startsWith('name', `${value.toLowerCase()}`)
      this.schools = []
      RegisterSchools.find().then((results) => {
        this.schools = []
        results.map((row) => {
          const { attributes } = row
          const i = removeDuplicateItem(this.schools, 'id', row.id)
          const data = {
            id: row.id,
            name: attributes.name,
            address: attributes.address,
            location: attributes.location,
            phone: attributes.phone,
            schoolId: attributes.schoolId
          }
          if (i === -1) {
            this.schools.push(data)
          } else {
            this.schools[i] = data
          }
          this.isSchoolAuto = true
          this.isOperateIndefendent = true
        })
        if (results.length === 0) {
          this.isOperateIndefendent = false
          this.loadMap()
        }
      })
    },
    googleMapSearchInput (event) {
      console.log(event.target.value)
      loader.load().then((google) => {
        document.getElementById('mwsMap').innerHTML = ''
        const map = new google.maps.Map(document.getElementById('mwsMap'), {
          center: this.center,
          zoom: 15
        })
        const input = document.getElementById('input-search')
        const searchBox = new google.maps.places.SearchBox(input)
        map.addListener('bounds_changed', () => {
          searchBox.setBounds(map.getBounds())
        })

        let markers = []
        searchBox.addListener('places_changed', () => {
          const places = searchBox.getPlaces()

          if (places.length === 0) {
            return
          }

          // Clear out the old markers.
          markers.forEach((marker) => {
            marker.setMap(null)
          })
          markers = []

          const bounds = new google.maps.LatLngBounds()
          places.forEach((place) => {
            if (!place.geometry || !place.geometry.location) {
              console.log('Returned place contains no geometry')
            }
            const marker = new (google.maps.Marker)({
              position: place.geometry.location,
              map: map
            })
            markers.push(marker)
            if (place.geometry.viewport) {
              // Only geocodes have viewport.
              bounds.union(place.geometry.viewport)
            } else {
              bounds.extend(place.geometry.location)
            }
          })
          map.fitBounds(bounds)
        })
      })
    },
    setPlaces (addressData, placeResultData, id) {
      const instance = this
      const place = addressData
      loader.load().then((google) => {
        document.getElementById('mwsMap').innerHTML = ''
        const map = new google.maps.Map(document.getElementById('mwsMap'), {
          center: this.center,
          zoom: 15
        })
        console.log(this.map, this.maps)
        const address = `${placeResultData.formatted_address}`
        const position = {
          lat: place.latitude,
          lng: place.longitude
        }
        const marker = new (google.maps.Marker)({
          position: position,
          map: map
        })
        const infowindow = new google.maps.InfoWindow({
          content: `Address: ${address}`
        })
        marker.addListener('click', () => {
          instance.showMarker(infowindow, address, marker, map)
        })
        map.setCenter(position)
      })
    },
    showMarker (infoWindow, address, name, marker, map) {
      console.log('hello')
      infoWindow.open({
        anchor: marker,
        map,
        shouldFocus: false
      })
      this.$emit('SchoolSelected', {
        address: address,
        name: name,
        registerSchoolId: '',
        schoolId: '',
        isOperateIndefendent: true,
        isSelectSchool: true
      })
    },
    geolocate: () => {
      navigator.geolocation.getCurrentPosition(position => {

      })
    }
  }
}

</script>

<style scoped>
.google-map {
  width: 100%;
  height: 400px;
  margin: 0 auto;
  background: gray;
}
</style>
